import React from "react";
import { cls } from "cls";

import { Button, ButtonProps } from "@clarkinc/zest-design-system/ui";

export type AddToCartProps = { "gtm-id"?: string } & ButtonProps;

const AddToCart = ({ className, children, ...rest }: AddToCartProps) => (
  <Button
    className={cls("wss", className)}
    variant="primary"
    color="red"
    {...rest}
  >
    {children}
  </Button>
);

export default AddToCart;
